import * as React from 'react';
import { useSelector, useDispatch } from "react-redux";
import './styles.css';
import { TextField, InputAdornment, ThemeProvider, createTheme, Popper, InputLabel, Box } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import Stack from '@mui/material/Stack';
import Autocomplete from '@mui/material/Autocomplete';
import { colors } from '../../common/pallette/colors';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faCaretDown } from '@fortawesome/free-solid-svg-icons';

const CustomPopper = styled(Popper)({
  '& .MuiAutocomplete-listbox': {
    fontSize: '14px',
  },
});

export default function SearchSelectBox(props: any) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { placeholder, selectedValue, options, variant, key, manageSelect, label, disabled, isError, errorMessage } = props;
  const [optionList, setOptionList] = React.useState([]);
  const [inputValue, setInputValue] = React.useState('');
  const [selectedOption, setSelectedOption] = React.useState(null);
  const [open, setOpen] = React.useState(false);

  
  const theme = createTheme({
    components: {
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            padding: '1.5px 2px !important',
            cursor: disabled ? 'not-allowed' : 'text'
          },
          notchedOutline: {
            borderColor: colors.black.dark,
          },
          input: {
            cursor: disabled ? 'not-allowed' : 'text'
          }
        }
      },
      MuiStack: {
        styleOverrides: {
          root: {
            width: '100% !important'
          }
        }
      },
      MuiInputBase: {
        styleOverrides: {
          input: {
            fontSize: '12px'
          }
        }
      },
      MuiInput: {
        styleOverrides: {
          root: {
            '& .Mui-disabled': {
              cursor: 'not-allowed',
            }
          },
          input: {
            '& .Mui-disabled': {
              cursor: 'not-allowed',
            }
          }
        }
      }
    }
  });

  React.useEffect(() => {
    if (options !== undefined) {
      setOptionList(options);
    }
  }, [options]);

  React.useEffect(() => {
    if(options != undefined) {
      const selectedObj = options.find((d: any) => (d.id == selectedValue || d.value == selectedValue));
      if (selectedObj === undefined) {
        setSelectedOption(null);
      } else {
        setSelectedOption(selectedObj);
        setInputValue(selectedObj.name);
      }
    }
  }, [selectedValue, options]);

  const handleChange = (_event: any, newValue: any) => {
    setSelectedOption(newValue);
    setInputValue(newValue ? newValue.name : '');
    manageSelect(newValue);
  };

  const handleInputChange = (_event: any, newInputValue: any) => {
    setInputValue(newInputValue);
  };

  return (
    <ThemeProvider theme={theme}>
      <Stack spacing={1} sx={{ '& > :not(style) ~ :not(style)': { marginTop: '0px' } }}>
        { label && label != '' && <InputLabel className='fs12' sx={{ textAlign: 'left', color: colors.black.dark }}>{label}</InputLabel>}
        <Autocomplete
          freeSolo
          className={'fs12'}
          open={open}
          onOpen={() => setOpen(true)}
          onClose={() => setOpen(false)}
          value={selectedOption}
          inputValue={inputValue}
          onChange={handleChange}
          onInputChange={handleInputChange}
          options={optionList}
          getOptionLabel={(option: any) => option.name || ''}
          sx={{ border: 0 }}
          PopperComponent={CustomPopper}
          readOnly={disabled}
          renderInput={(params) => (
            <TextField
              {...params}
              sx={{ border: 0 }}
              placeholder={placeholder ? placeholder : ""}
              className='fs12'
              variant={variant ? variant : 'outlined'}
              error={isError}
              helperText={isError ? errorMessage : ''}
              disabled={disabled}
              InputProps={{
                ...params.InputProps,
                type: 'search',
                endAdornment: (
                  <InputAdornment position="end">
                    <Box
                      className="cursorPointer"
                      onClick={() => setOpen(!open)}
                      sx={{ display: 'flex', flexDirection: 'column', mr: '10px' }}
                    >
                      <FontAwesomeIcon className="icon" fontSize="12px" icon={faBars} />
                      <FontAwesomeIcon className="icon" fontSize="12px" icon={faCaretDown} />
                    </Box>
                  </InputAdornment>
                ),
              }}
            />
          )}
        />
      </Stack>
    </ThemeProvider>
  );
}
